import React from 'react'

import { SKULL_SIMPLE } from '../utils/asciiArt'

import styles from './SkullWarning.module.css'

interface SkullWarningProps {
  message?: string
  visible?: boolean
}

const SkullWarning: React.FC<SkullWarningProps> = ({
  message = 'CRITICAL EXPLOIT',
  visible = true,
}) => {
  if (!visible) return null

  return (
    <div className={styles.container}>
      <pre className={styles.skull}>{SKULL_SIMPLE}</pre>
      <div className={styles.message}>{message}</div>
      <div className={styles.triangles}>
        <span className={styles.triangle}>⚠</span>
        <span className={styles.triangle}>⚠</span>
        <span className={styles.triangle}>⚠</span>
      </div>
    </div>
  )
}

export default SkullWarning
